"use client"

import { useEffect } from "react"
import { reportClientError, handleVeralteterBuild, clearVeralteterBuildMerker } from "@/lib/client-error-report"

/**
 * Fängt global unbehandelte Browser-Fehler ab und meldet sie an
 * `/client-logs` — damit Crashs im Browser (die der Server-Log nicht sieht)
 * in der Admin-Seite „Frontend-Logs" sichtbar werden. Rendert nichts.
 */
export default function GlobalErrorReporter() {
  useEffect(() => {
    // Die Seite steht — ein vorheriges Neuladen wegen veralteter Chunks war erfolgreich.
    clearVeralteterBuildMerker()

    const onError = (e: ErrorEvent) => {
      const msg = e.error?.stack || e.message || "Unbekannter Fehler"
      reportClientError(`window.onerror: ${msg}`)
      handleVeralteterBuild(msg)
    }
    const onRejection = (e: PromiseRejectionEvent) => {
      const r = e.reason
      const msg = (r && (r.stack || r.message)) || String(r)
      reportClientError(`unhandledrejection: ${msg}`)
      handleVeralteterBuild(msg)
    }
    window.addEventListener("error", onError)
    window.addEventListener("unhandledrejection", onRejection)
    return () => {
      window.removeEventListener("error", onError)
      window.removeEventListener("unhandledrejection", onRejection)
    }
  }, [])
  return null
}
